import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { InstantPaymentResponse } from '../../../../../lib/ezidebit';
import { PaymentReference } from './instant-payment.component';
import { centsToDollars } from '../../utils';

@Component({
  selector: 'app-shared-instant-payment-modal',
  templateUrl: './instant-payment-modal.component.html'
})
export class SharedInstantPaymentModalComponent {
  @Input() title: string;
  @Input() successfulMessage: string;
  @Input() createReference: (amount: number) => Observable<PaymentReference>;
  fixedAmountInDollars?: number;
  @Input() allowComments = true;
  @Input() saveReference: (paymentReference: string, amount: number) => Observable<{}>;
  @Output() onSuccess = new EventEmitter<InstantPaymentResponse>();
  @Output() onError = new EventEmitter<InstantPaymentResponse>();
  @ViewChild('instantPayment') instantPayment;
  paymentReference: string | null = null;
  paymentSuccess: boolean | null = null;
  paymentError: boolean | null = null;
  errorMessage: string | null = null;
  active = false;

  open() {
    this.active = true;
    this.paymentReference = null;
    this.paymentSuccess = null;
    this.paymentError = null;
    this.errorMessage = null;
  }

  close() {
    this.active = false;
  }

  setFixedAmountInDollars(amount: number) {
    this.fixedAmountInDollars = amount;
  }

  onSuccessfulPayment(instantPaymentResponse: InstantPaymentResponse) {
    const {paymentReference} = instantPaymentResponse;
    this.paymentReference = paymentReference;
    this.paymentSuccess = null;
    this.paymentError = null;
    this.errorMessage = null;

    this.saveReference(paymentReference, centsToDollars(this.instantPayment.getAmount()))
      // @ts-ignore: Type 'void' is not assignable to type ObservableInput<{}>
      .catch(() => {
        this.paymentError = true;
        return Observable.of({});
      })
      .subscribe(() => {
        this.onSuccess.emit(instantPaymentResponse);
        this.paymentSuccess = true;
      });
  }

  onUnsuccessfulPayment(instantPaymentResponse: InstantPaymentResponse) {
    const {message} = instantPaymentResponse;
    this.onError.emit(instantPaymentResponse);
    this.paymentSuccess = null;
    this.paymentError = true;
    this.errorMessage = message;
  }

  showPaymentForm() {
    return this.paymentError === true || this.paymentSuccess === true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/payments/instant-payment-modal.component.ts